function ellipsis(str1, maxLength) {
    let str = String(str1)
    let strList = str.split(/\r?\n/)
    if (strList[0].length > maxLength)
    {
        return strList[0].substr(0, maxLength) + '...';
    }
    else
    {
        if(strList.length > 1){
            return strList[0] + '...'
        }
        return str;
    }
}

export default ellipsis;



// WEBPACK FOOTER //
// ./src/lib/ellipsis.js